import _ from "lodash";

export default function(message, shop, fields) {
  let previewFields = null;

  if (!fields) {
    previewFields = {
      FirstName: "John",
      LastName: "Smith",
      Country: "United States",
      City: "Los Angeles",
      Province: "Los Angeles",
      FullAddress: "123 Hope St, Los Angeles CA 90001, United States",
      ShopName: shop.displayName,
      ShopUrl: "https://" + shop.shortUrlDomain + "/aA0bc",
      DiscountCode: "XY5GT",
    };
  } else {
    previewFields = fields;
  }

  if (!message) {
    return "";
  }

  let template = message;

  const r = template.match(/\{[\w]+\}/g);
  const _urlRegex = template.match(/(?:^|\s)https?:\/\/[^\s<]*(?:$|\.|,|\s)/g);

  r &&
    r.forEach((state) => {
      const regex = new RegExp(state, "g");
      const stateItem = state.split(/{|}/g)[1];
      template = template.replace(regex, previewFields[stateItem]);
    });

  _urlRegex &&
    _urlRegex.forEach((state) => {
      let cleanUrlStart = "";
      let cleanUrlEnd = "";
      let extraCharStart = "";
      let extraCharEnd = "";

      cleanUrlStart = _.trimStart(state, ".,! ");
      cleanUrlEnd = _.trimEnd(state, ".,! ");
      extraCharStart = state.substring(0, state.length - cleanUrlStart.length);
      extraCharEnd = state.substring(state.length, cleanUrlEnd.length);

      if (_.trim(state, " ") === "https://") {
        //
      } else {
        template = template.replace(
          state,
          extraCharStart + previewFields.ShopUrl + extraCharEnd
        );
      }
    });

  if (
    template.substring(template.length - 1) === "." ||
    template.substring(template.length - 1) === "!" ||
    template.substring(template.length - 1) === " "
  ) {
    template = template + " Reply STOP to opt out.";
  } else {
    template = template + ". Reply STOP to opt out.";
  }

  return template;
}
